const styles = {
  realTalkLabel: {
    height: '50px',
    border: '0px',
    margin: '0px 0px',
    /*borderBottom: 'solid 3px rgba(0, 0, 0, 0.08)',*/
    paddingLeft: '0px',
    position: 'relative',
  },

  realTalkLabelText: {
    marginLeft: '20px',
    fontFamily: 'FuturaTodayBold',
    fontSize: '21px',
    color: '#333333',
  },

  realTalkLabelUnderline: {
    width: '147px',
    height: '5px',
    backgroundColor: '#dd9933',
    position: 'absolute',
    bottom: '0',
    left: '0',
  },

  largeQuoteMark: {
    fontFamily: 'FuturaTodayBold',
    fontSize: '34px',
    fontWeight: 'bold',
    lineHeight: '.65',
    letterSpacing: '1.3px',
    textAlign: 'left',
    color: '#dd9933',
  },

  mediumQuoteMark: {
    fontFamily: 'FuturaTodayBold',
    fontSize: '34px',
    fontWeight: 'bold',
    lineHeight: '.45',
    letterSpacing: '1.3px',
    textAlign: 'left',
    color: '#dd9933',
    position: 'relative',
    top: '6px',
  },

  realTalkGrid: {
      marginLeft: '0px',
      marginRight: '0px',
  },

  realTalkGridColumn: {
      marginLeft: '0px',
      marginRight: '0px',
      paddingLeft: '0px',
      paddingRight: '0px',
  },

  largeQuoteText: {
    fontFamily: 'FuturaTodayDemiBold',
    fontSize: '28px',
    lineHeight: '1.14',
    textAlign: 'left',
    color: '#333333',
    display: 'inline-block',
    margin: '10px 0px 20px 40px',
  },

  mediumQuoteText: {
    fontFamily: 'FuturaTodayDemiBold',
    fontSize: '16px',
    lineHeight: '1.38',
    textAlign: 'left',
    color: '#333333',
    margin: '20px 12px 20px 12px',
    paddingLeft: '12px',
    paddingRight: '12px',
  },

  fullAccessLabel: {
    height: '60px',
    border: '0px',
    margin: '0px 0px',
    /* borderBottom: "solid 3px rgba(0, 0, 0, 0.08)",*/
    /* position: "relative",*/
    backgroundColor: '#dd9933',
    lineHeight: 'normal',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px',
  },

  fullAccessLabelText: {
    fontFamily: 'FuturaTodayDemiBold',
    fontSize: '24px',
    color: '#ffffff',
    verticalAlign: 'middle',
  },

  fullAccessButton: {
    width: '130px',
    height: '36px',
    borderRadius: '3px',
    backgroundColor: '#ffffff',
    boxShadow: '0 2px 0 0 rgba(0, 0, 0, 0.08)',
    fontFamily: 'FuturaTodayBold',
    fontSize: '14px',
    lineHeight: '1.43',
    letterSpacing: '0.4px',
    textAlign: 'center',
    color: '#dd9933',
    padding: '0px',
    marginLeft: '30px',
    verticalAlign: 'middle',
  },

  fullAccessIcon: {
    marginRight: '20px',
  },

  AttributionNameText: {
    fontFamily:
      "'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif",
    fontSize: '13px',
    lineHeight: '1.38',
    textAlign: 'left',
    color: '#666666',
    fontWeight: 'bold',
    marginLeft: '40px',
    marginBottom: '0px',
  },

  AttributionLabelText: {
    fontFamily:
      "'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif",
    fontSize: '13px',
    lineHeight: '1.38',
    textAlign: 'left',
    color: '#666666',
    margin: '0px auto 22px 40px',
  },

  MedAttributionNameText: {
    fontFamily:
      "'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif",
    fontSize: '13px',
    lineHeight: '1.38',
    textAlign: 'left',
    color: '#666666',
    fontWeight: 'bold',
    marginLeft: '24px',
    marginBottom: '0px',
  },

  MedAttributionLabelText: {
    fontFamily:
      "'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif",
    fontSize: '13px',
    lineHeight: '1.38',
    textAlign: 'left',
    color: '#666666',
    margin: '0px auto 22px 24px',
  },

  quote: {
    position: 'relative',
    top: '25px',
    left: '20px',
    fontFamily: 'FuturaTodayBold',
    fontSize: '34px',
    color: '#dd9933',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/app/components/Footer/DesktopFooter/DesktopRealTalk.styles.js